import { createReducer, createAction } from 'redux-act';
import { Metadata } from '../../services/metadata';
import { useSelector } from 'react-redux';
import { IGlobalState } from '../index';

export type IState = Partial<Metadata>;

export const setMetadata = createAction<IState>('set metadata');

export const metadataReducer = createReducer({}, {} as IState).on(setMetadata, (_, data) => data);

export const useMetadata = () => {
    return useSelector((state: IGlobalState) => state.metadata);
};
